import React, { Fragment, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Header from 'components/sales/header';
import DutyBar from 'components/attendance/DutyBar/DutyBar';
import SideBar from 'components/sales/sidebar/sideBar';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import DashboardRoutes from './dashboardRoutes/dashboardRoutes';
import AppNotifications from 'components/sales/appNotifications/appNotifications';
import Pusher from 'pusher-js';
import Loader from 'components/sales/Loader/loader';

const Dashboard = ({
  match,
  getProfile,
  userData,
  fetchUnreadNotifications,
  fetchAllNotifications,
  unreadNotifications,
  allNotifications,
  viewCart,
  addInCart,
  getDashboardCount,
  dashboardCount,
  checkDarwinAttendance,
}) => {
  const [activeComponent, setActiveComponent] = useState();
  const [isConnected, setIsConnected] = useState(false);
  const [userId, setUserId] = useState();
  const [notification, setNotification] = useState('');
  const [unreadCount, setUnreadCount] = useState(0);
  const [unreadList, setUnreadList] = useState(0);
  const [notificationsList, setNotificationsList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const isDarwinAttendanceEligible =
    userData.attendanceTabFlag && !userData.role.includes(9);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    prevPathRef.current = location.pathname;

    const attendancePaths = [
      '/check_in',
      '/check_out',
      '/attendance/check-in-checkout',
    ];
    const isAttendancePath = (path) =>
      attendancePaths.some((attendancePath) => path.includes(attendancePath));
    const leftAttendancePage =
      isAttendancePath(prevPath) && !isAttendancePath(location.pathname);

    if (leftAttendancePage && getProfile) {
      getProfile();
      if (checkDarwinAttendance && isDarwinAttendanceEligible) {
        checkDarwinAttendance();
      }
    }
  }, [
    location.pathname,
    getProfile,
    checkDarwinAttendance,
    isDarwinAttendanceEligible,
  ]);

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles && setUserId(roles[0].pivot.user_id);
      })();
    }, 1000);
  }, []);

  // useEffect(() => {
  //   (async () => {
  //     const res = await fetchUnreadNotifications();
  //     if (res) {
  //       setUnreadList(res || unreadNotifications);
  //       setUnreadCount(res?.length || unreadNotifications?.length);
  //     }
  //   })();
  // }, [fetchUnreadNotifications]);

  const onClickReadAll = async () => {
    const res = await fetchAllNotifications();
    if (res) {
      setNotificationsList(allNotifications);
    }
  };

  if (userId) {
    // Enable pusher logging - don't include this in production
    Pusher.logToConsole = false;
    const pusher = new Pusher(`${process.env.REACT_APP_PUSHER_APP_KEY}`, {
      cluster: `${process.env.REACT_APP_PUSHER_APP_CLUSTER}`,
    });

    const channel = pusher.subscribe(`parkplus-development-${userId}`);
    channel.bind('park-notification', function (data) {
      setNotification(data.message);
      setIsConnected(true);
      setUnreadCount(unreadCount + 1);
    });
  }

  const createLead = async () => {
    if (userData.departmentId.includes(2)) {
      if (userData.teamId.includes(7)) {
        setActiveComponent('corporate');
      } else if (userData.teamId.includes(9)) {
        setActiveComponent('supply');
      } else if (userData.teamId.includes(8)) {
        setActiveComponent('apartments');
      } else {
        setActiveComponent('b2b-alliances');
      }
    }
    if (userData.departmentId.includes(3)) {
      if (userData.teamId.includes(1)) {
        setActiveComponent('installation');
      }
    }
    if (userData.departmentId.includes(3)) {
      if (userData.teamId.includes(2)) {
        setActiveComponent('maintenance');
      }
    }
    if (userData.departmentId.includes(3)) {
      if (userData.teamId.includes(4)) {
        setActiveComponent('brand-activation');
      }
    }
    if (userData.departmentId.includes(9)) {
      if (userData.teamId.includes(16)) {
        setActiveComponent('parking');
      }
    }
  };

  useEffect(() => {
    if (userData.departmentId && userData.teamId) {
      createLead();
    }
  }, [userData.departmentId, userData.teamId]);

  useEffect(() => {
    if (getProfile !== null)
      (async () => {
        setIsLoading(true);
        await getProfile();
        setIsLoading(false);
      })();
  }, [getProfile]);

  useEffect(() => {
    if (checkDarwinAttendance && isDarwinAttendanceEligible) {
      checkDarwinAttendance();
    }
  }, [checkDarwinAttendance, isDarwinAttendanceEligible]);

  const closeToast = () => {
    setIsConnected(!isConnected);
  };

  useEffect(() => {
    if (activeComponent === 'brand-activation')
      (async () => await addInCart(null))();
  }, [activeComponent]);

  return (
    
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <Fragment>
        <AppNotifications
          closeToast={closeToast}
          visible={isConnected}
          message={notification}
          isSuccess
        />
        <Header
          unreadList={unreadList}
          unreadCount={unreadCount}
          notificationsList={allNotifications || notificationsList}
          onClickReadAll={onClickReadAll}
          activeComponent={activeComponent}
          role={userData.role}
          attCheckIn={userData.attCheckIn}
          attCheckInSite={userData.attCheckInSite}
          isJourneyStarted={userData.isJourneyStarted}
          isDarwinCheckedIn={userData.isDarwinCheckedIn}
          hasOpenDarwinDuty={userData.hasOpenDarwinDuty}
          hasOpenDutyToday={userData.hasOpenDutyToday}
          departmentId={userData.departmentId}
          viewCart={viewCart}
          userAlert={userData?.userAlerts}
        />

        <DutyBar />

        <div className="body-container">
          <SideBar
            activeComponent={activeComponent}
            departmentId={userData.departmentId}
            teamId={userData.teamId}
            role={userData.role}
            attCheckIn={userData.attCheckIn}
            attCheckInSite={userData.attCheckInSite}
            siteInfoFeature={userData.siteInfoFeature}
            getDashboardCount={getDashboardCount}
            userId={userData.userId}
            isApprovalAllowed={userData.isApprovalAllowed}
            attendanceTabFlag={userData.attendanceTabFlag}
            darwinManagerCheck={userData.darwinManagerCheck}
          />
          <DashboardRoutes
            activeComponent={activeComponent}
            baseUrl={match.url}
            departmentId={userData.departmentId}
            role={userData.role}
            attCheckInSite={userData.attCheckInSite}
            attCheckIn={userData.attCheckIn}
            teamId={userData.teamId}
          />
        
            
        </div>
        
      </Fragment>
      <Loader isLoading={isLoading} />
    </BaseUrl.Provider>
  );
};

Dashboard.propTypes = {
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

export default Dashboard;
